<script setup lang="ts">
import {Mail, MapPin, Phone, Send} from "lucide-vue-next";

import "@/assets/styles/contact.css";
</script>

<template>

  <section class="contact-section" id="contact">

    <!-- Header -->
    <div class="contact-header">

      <span class="section-badge">
        Kontakt
      </span>

      <h2>
        Lassen Sie uns Ihr Projekt starten
      </h2>

      <p>
        Sie planen eine neue Außenanlage,
        benötigen Unterstützung bei der Gartenpflege
        oder möchten sich beraten lassen?
      </p>

    </div>

    <!-- Content -->
    <div class="contact-container">

      <!-- Kontaktinfos -->
      <div class="contact-info">

        <div class="info-card">

          <div class="info-icon">
            <Phone/>
          </div>

          <div>
            <h3>Telefon</h3>
            <p>+49 123 456789</p>
          </div>

        </div>

        <div class="info-card">

          <div class="info-icon">
            <Mail/>
          </div>

          <div>
            <h3>E-Mail</h3>
            <p>info@testgarten.de</p>
          </div>

        </div>

        <div class="info-card">

          <div class="info-icon">
            <MapPin/>
          </div>

          <div>
            <h3>Standort</h3>
            <p>Wiesbaden & Umgebung</p>
          </div>

        </div>

      </div>

      <!-- Formular -->
      <div class="contact-form-wrapper">

        <form class="contact-form">

          <div class="form-grid">

            <div class="form-group">
              <label>Name</label>
              <input type="text" placeholder="Ihr Name"/>
            </div>

            <div class="form-group">
              <label>E-Mail</label>
              <input type="email" placeholder="ihre@email.de"/>
            </div>

          </div>

          <div class="form-group">
            <label>Telefon</label>
            <input type="text" placeholder="+49 ..."/>
          </div>

          <div class="form-group">
            <label>Nachricht</label>
            <textarea
                rows="6"
                placeholder="Beschreiben Sie Ihr Projekt..."
            />
          </div>

          <button type="submit" class="submit-btn">

            <Send/>

            Anfrage senden

          </button>

        </form>

      </div>

    </div>

  </section>

</template>

<style scoped>
</style>